import {
  getToken,
  setToken,
  removeToken,
  setLocalStorage,
  getLocalStorage
} from "@/utils/auth";
import { login, register, updateUserInfo } from "@/api/user";
import { getZfbAccessToken, getAccessToken, getWxUserInfo } from "@/api/wechat";
const user = {
  state: {
    token: getToken("NineBit_Authorization"),
    cvs: getToken("isNewRevision"),
    name: getLocalStorage("WX_User_Name"),
    avatar: getLocalStorage("WX_User_Avatar"),
    NBPSS: getLocalStorage("NINEBITSS"), //九比特平台用户信息
    wx_portrait: getLocalStorage("WX_User_Portrait"), //微信平台用户信息
    wx_token: getToken("Wx_Authorization"),
    wx_userInfo: getLocalStorage("wxapi_userinfo"),
    zfb_portrait: getLocalStorage("Zfb_User_Portrait"),
    zfb_token: getToken("Zfb_Authorization"),
    zfb_userInfo: getLocalStorage("zfbapi_userinfo"),
    CJ_Phone: getLocalStorage("cj_phone"),
    roles: []
  },
  mutations: {
    SET_PHONE: (state, data) => {
      setLocalStorage("cj_phone", data);
      state.CJ_Phone = data;
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_CVS: (state, cvs) => {
      state.cvs = cvs;
      setToken("isNewRevision", 1, 4 * 60 * 60);
    },
    SET_NINEBITSS_USERINFO: (state, data) => {
      setLocalStorage("NINEBITSS", data);
      state.NBPSS = JSON.parse(JSON.stringify(data));
    },
    SET_WXTOKEN: (state, wx_token) => {
      state.wx_token = wx_token;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_WX_PORTRAIT: (state, data) => {
      state.wx_portrait = JSON.parse(JSON.stringify(data));
    },
    SET_WXAPI_USERINFO: (state, data) => {
      setLocalStorage("wxapi_userinfo", data);
      state.wx_userInfo = JSON.parse(JSON.stringify(data));
    },
    SET_ZFBAPI_USERINFO: (state, data) => {
      setLocalStorage("zfbapi_userinfo", data);
      state.zfb_userInfo = JSON.parse(JSON.stringify(data));
    },
    ClEAR_SESSION () {
      removeToken("NineBit_Authorization");
      removeToken("Wx_Authorization");
      removeToken("Zfb_Authorization");
      window.localStorage.clear();
    },
    SET_ZFB_PORTRAIT: (state, data) => {
      state.zfb_portrait = JSON.parse(JSON.stringify(data));
    }
  },

  actions: {
    // 保存手机
    SetPhone ({ commit }, data) {
      commit("SET_PHONE", data);
    },
    // 设置微信用户鉴权
    wxAuthentication ({ commit }, params) {
      return new Promise((resolve, reject) => {
        getAccessToken(params)
          .then(res => {
            let data = res.body;
            if (res.status === 1001) {
              setToken("Wx_Authorization", data.access_token, data.expires_in);
              commit("SET_WXAPI_USERINFO", data);
              commit("SET_WXTOKEN", data.access_token);
            }
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 设置支付宝用户鉴权
    zfbAuthentication ({ commit }, params) {
      return new Promise((resolve, reject) => {
        getZfbAccessToken(params)
          .then(res => {
            let data = res.body;
            if (res.status === 1001) {
              commit("SET_ZFBAPI_USERINFO", data);
              // setToken("Zfb_Authorization", data.access_token, data.expires_in);
              // commit("SET_ZFBTOKEN", data.access_token);
            }
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 登录
    Login ({ commit }, params) {
      return new Promise((resolve, reject) => {
        login(params)
          .then(res => {
            const data = res.body;
            if (data != null && Object.keys(data).length > 0) {
              setToken("NineBit_Authorization", data.userId, 7200);
              commit("SET_NINEBITSS_USERINFO", data);
              commit("SET_TOKEN", data.userId);
            }
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    // 注册
    Register ({ commit }, params) {
      return new Promise((resolve, reject) => {
        register(params)
          .then(res => {
            const data = res.body;
            if (data != null) {
              setToken("NineBit_Authorization", data.userId, 7200);
              commit("SET_TOKEN", data.userId);
            }
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 绑定用户和平台标识
    BindUserAndPid ({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateUserInfo(params)
          .then(res => {
            const data = res.body;
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 获取微信用户信息
    GetWXUserInfo ({ commit }, params) {
      return new Promise((resolve, reject) => {
        getWxUserInfo(params)
          .then(res => {
            commit("SET_NAME", res.body.nickname);
            commit("SET_AVATAR", res.body.headimgurl);
            commit("SET_WX_PORTRAIT", res.body);
            setLocalStorage("WX_User_Portrait", res.body || null);
            setLocalStorage("WX_User_Avatar", res.body.headimgurl || null);
            setLocalStorage("WX_User_Name", res.body.nickname || null);
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 打开/关闭登录弹窗
    SetLoginAnchor ({ commit }, data) {
      commit("SET_LOGIN_ANCHOR", data);
    },
    SetCvs ({ commit }, data) {
      commit("SET_CVS", data);
    },
    // 清除缓存
    ClearSession ({ commit }) {
      commit("ClEAR_SESSION");
    },
    // 前端 登出
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit("ClEAR_SESSION");
        resolve();
      });
    }
  }
};

export default user;
